import { asyncComponent } from '~utils/components'
import Spinner from 'components/Spinner'

export const LazyDocumentAuto = asyncComponent(
  () => import(/* webpackChunkName: "documentAuto" */ './DocumentAuto'),
  Spinner
)
